import { ErrorBoundary, Provider } from '@rollbar/react';
import { QueryClientProvider } from '@tanstack/react-query';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import App from '@/App';
import { ActionCableProvider } from '@/context/action-cable-provider';
import AuthContextProvider from '@/context/auth/auth-context-provider';
import { ThemeProvider } from '@/context/theme-provider';
import { queryClient } from '@/lib/query-client';
import rollbar from '@/lib/rollbar/config';

import '@/lib/i18n';
import '@/index.css';

// After Giving the design by design team it will be removed and replaced by the design provided by them
const AppErrorFallback = () => (
  <div style={{ padding: '20px', textAlign: 'center' }}>
    <h1>Something went wrong.</h1>
    <p>The error has been reported to our team.</p>
  </div>
);

export default AppErrorFallback;

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Provider instance={rollbar}>
      <ErrorBoundary fallbackUI={AppErrorFallback}>
        <QueryClientProvider client={queryClient}>
          <ThemeProvider>
            <AuthContextProvider>
              <ActionCableProvider>
                <App />
              </ActionCableProvider>
            </AuthContextProvider>
          </ThemeProvider>
        </QueryClientProvider>
      </ErrorBoundary>
    </Provider>
  </StrictMode>
);
